import { defineMessages } from 'react-intl';

export default defineMessages({
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.noInfo',
        defaultMessage: 'No information is available to display'
    },
    locationInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Location Information',
        defaultMessage: 'Location Information'
    },
    garagingLocation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Garaging Location',
        defaultMessage: 'Garaging Location'
    },
    county: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.County',
        defaultMessage: 'County'
    },
    taxTown: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Tax Town',
        defaultMessage: 'Tax Town'
    },
    territory: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Territory',
        defaultMessage: 'Territory'
    },
    acrossStreetTerritory: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Across the Street Territory',
        defaultMessage: 'Across the Street Territory'
    },
    primaryResidence: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Primary Residence',
        defaultMessage: 'Primary Residence'
    },
    vehicleSymbols: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Vehicle Symbols',
        defaultMessage: 'Vehicle Symbols'
    },
    VEHICLE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.VEHICLE',
        defaultMessage: 'VEHICLE'
    },
    COMP_SYMBOL: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.COMP SYMBOL',
        defaultMessage: 'COMP SYMBOL'
    },
    COLLISION_SYMBOL: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.COLLISION SYMBOL',
        defaultMessage: 'COLLISION SYMBOL'
    },
    signal: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Signal',
        defaultMessage: 'Signal'
    },
    DRIVER_NAME: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.DRIVER NAME',
        defaultMessage: 'Driver Name'
    },
    DATE_OF_BIRTH: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.DATE OF BIRTH',
        defaultMessage: 'Date of Birth'
    },
    CELL_PHONE_NUMBER: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.CELL PHONE NUMBER',
        defaultMessage: 'Cell Phone Number'
    },
    ENROLLMENT_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.ENROLLMENT DATE',
        defaultMessage: 'Enrollment Date'
    },
    ENROLLMENT_STATUS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.ENROLLMENT STATUS',
        defaultMessage: 'Enrollment Status'
    },
    SCORE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.SCORE',
        defaultMessage: 'Score'
    },
    SCORE_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.SCORE DATE',
        defaultMessage: 'Score Date'
    },
    LAST_ERROR_MESSAGE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.LAST ERROR MESSAGE',
        defaultMessage: 'Last Error Message'
    },
    hazardInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Hazard Information',
        defaultMessage: 'Hazard Information'
    },
    fireSubscriptionIndicator: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Fire Subscription Indicator',
        defaultMessage: 'Fire Subscription Indicator'
    },
    geoProtect: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.GeoProtect',
        defaultMessage: 'GeoProtect'
    },
    texasWindInspection: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Texas Wind Inspection',
        defaultMessage: 'Texas Wind Inspection'
    },
    brushFireScore: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Brush Fire - Score',
        defaultMessage: 'Brush Fire - Score'
    },
    riskEligibility: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Risk Eligibility',
        defaultMessage: 'Risk Eligibility'
    },
    windHailRiskGroup: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Wind/Hail Risk Category Applicable to ZIP Code',
        defaultMessage: 'Wind/Hail Risk Category Applicable to ZIP Code'
    },
    wildFireRiskGroup: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Wildfire Risk Category Applicable to ZIP Code',
        defaultMessage: 'Wildfire Risk Category Applicable to ZIP Code'
    },
    coastalFlooding: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Coastal/Flooding',
        defaultMessage: 'Coastal/Flooding'
    },
    proximityToTidalWater: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Proximity to Tidal Water - Distance (ft)',
        defaultMessage: 'Proximity to Tidal Water - Distance (ft)'
    },
    inOutFloodZone: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Flood - SFHA In/Out',
        defaultMessage: 'Flood - SFHA In/Out'
    },
    windBuildingZone: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Wind Building Zone',
        defaultMessage: 'Wind Building Zone'
    },
    perilScoreInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Peril Score Information',
        defaultMessage: 'Peril Score Information'
    },
    distanceToFireStation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Distance to Fire Station (mi)',
        defaultMessage: 'Distance to Fire Station (mi)'
    },
    protectionClassCode: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Protection Class Code',
        defaultMessage: 'Protection Class Code'
    },
    fireDistrict: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Fire District',
        defaultMessage: 'Fire District'
    },
    matchUsing: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Match Using',
        defaultMessage: 'Matched Using'
    },
    hydrantWithIn1000ft: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Hydrant within 1000 ft',
        defaultMessage: 'Hydrant within 1,000 feet'
    },
    ratedProtectionClass: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Rated Protection Class',
        defaultMessage: 'Rated Protection Class'
    },
    distanceToFireStationNp: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Distance to Fire Station',
        defaultMessage: 'Distance to Fire Station'
    },
    protectionClassOverride: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Protection Class Override',
        defaultMessage: 'Protection Class Override'
    },
    alternatePPC: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Alternative PPC ',
        defaultMessage: 'Alternative PPC'
    },
    locationFireScore: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Location Fire Score',
        defaultMessage: 'Location Fire Score'
    },
    chargeableIncidents: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Chargeable Incidents',
        defaultMessage: 'Incidents'
    },
    losses: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Losses',
        defaultMessage: 'Losses'
    },
    CLAIM_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.CLAIM DATE',
        defaultMessage: 'CLAIM DATE'
    },
    TOTAL_AMOUNT_PAID: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.TOTAL AMOUNT PAID',
        defaultMessage: 'TOTAL AMOUNT PAID'
    },
    DESCRIPTION: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    VEHICLE_OPERATOR: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.VEHICLE OPERATOR',
        defaultMessage: 'VEHICLE OPERATOR'
    },
    violations: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Violations',
        defaultMessage: 'Violations'
    },
    DATE_OF_INCIDENT: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.DATE OF INCIDENT',
        defaultMessage: 'DATE OF INCIDENT'
    },
    CONVICTION_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.CONVICTION DATE',
        defaultMessage: 'CONVICTION DATE'
    },
    INCIDENT_TYPE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.INCIDENT TYPE',
        defaultMessage: 'INCIDENT TYPE'
    },
    rateCapping: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Rate Capping',
        defaultMessage: 'Rate Capping'
    },
    cappingInEffect: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Capping in Effect',
        defaultMessage: 'Capping in Effect'
    },
    cappingType: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Capping Type',
        defaultMessage: 'Capping Type'
    },
    perilCapped: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Peril Capped',
        defaultMessage: 'Peril Capped'
    },
    bookRoll: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Book Roll',
        defaultMessage: 'Book Roll'
    },
    BOOK_ROLL_INDICATOR: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.BOOK ROLL INDICATOR',
        defaultMessage: 'BOOK ROLL INDICATOR'
    },
    customerDocuments: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Customer Documents',
        defaultMessage: 'Customer Documents'
    },
    viewDocuments: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.View Documents',
        defaultMessage: 'View Documents'
    },
    serviceLevelInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Service Level Information',
        defaultMessage: 'Service Level Information'
    },
    SERVICE_LEVEL: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.SERVICE LEVEL',
        defaultMessage: 'SERVICE LEVEL'
    },
    SERVICE_COUNT: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.SERVICE COUNT',
        defaultMessage: 'SERVICE COUNT'
    },
    driversName: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Drivers Name',
        defaultMessage: 'Drivers Name'
    },
    dateOfBirth: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    gender: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Gender',
        defaultMessage: 'Gender'
    },
    licenseNumber: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.License #',
        defaultMessage: 'License Number'
    },
    licenseState: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.License State',
        defaultMessage: 'License State'
    },
    year: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Year',
        defaultMessage: 'Year'
    },
    make: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Model',
        defaultMessage: 'Model'
    },
    vin: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Vehicle Identification Number',
        defaultMessage: 'Vehicle Identification Number'
    },
    vehicleDisposition: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Vehicle Disposition',
        defaultMessage: 'Vehicle Disposition'
    },
    COVERAGE_TYPE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.COVERAGE TYPE',
        defaultMessage: 'COVERAGE TYPE'
    },
    AMOUNT_PAID: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.AMOUNT PAID',
        defaultMessage: 'AMOUNT PAID'
    },
    STATUS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.STATUS',
        defaultMessage: 'STATUS'
    },
    name: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Name',
        defaultMessage: 'Name'
    },
    description: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Description',
        defaultMessage: 'Description'
    },
    actOfGod: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Act of God',
        defaultMessage: 'Act of God'
    },
    catIndicator: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.CAT Indicator',
        defaultMessage: 'CAT Indicator'
    },
    close: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Close',
        defaultMessage: 'Close'
    },
    connectedCar: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Connected Car',
        defaultMessage: 'Connected Car'
    },
    publicProtectionClass: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Public Protection Class ',
        defaultMessage: 'Public Protection Class '
    },
    priorUBIScoreGroup: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Prior UBI Score Group ',
        defaultMessage: 'Prior UBI Score Group '
    }, 
    ratedUBIScoreGroup: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Rated UBI Score Group ',
        defaultMessage: 'Rated UBI Score Group '
    }, 
    participationGroup: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Participation Group ',
        defaultMessage: 'Participation Group '
    }, 
    estimatedSignalPercentage: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorCompanyUse.Estimated Signal %',
        defaultMessage: 'Estimated Signal % '
    },
});